import { getUserInternalAccessToken } from "@/api/access-token-backoffice";

export interface CampaignTemplate {
  id: number;
  name: string;
  description?: string;
  template: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface GetAllCampaignTemplatesResponse {
  data: CampaignTemplate[];
  totalCount: number;
}

export async function getAllCampaignTemplates(): Promise<GetAllCampaignTemplatesResponse> {
  // Chamada direta ao backoffice: evita depender de rotas internas que não existem em ambientes hospedados
  const { accessToken } = await getUserInternalAccessToken();

  const backofficeApiUrl =
    import.meta.env.VITE_API_BACKOFFICE_URL || "https://api-backoffice-qas.talk2buy.com.br";
  const response = await fetch(`${backofficeApiUrl}/v1/campaigntemplate?pageNumber=1&pageSize=50`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    throw new Error(`Backend API error! status: ${response.status}`);
  }

  const data = await response.json();

  return {
    data: data.items || data.data || [],
    totalCount: data.totalCount || 0,
  };
}
